import React from 'react';
import { pxToRem } from '@/modules/config';
import { TOPIC_TYPES } from '../types';
import type { Topic } from '../types';

/** The uppercase topic-type label shown under the title in the read hero. */
const TopicTypeBadge: React.FC<{ topic: Topic }> = ({ topic }) => {
  const selected = TOPIC_TYPES.find(t => t.id === topic.type);
  if (!selected) return null;
  return (
    <span
      data-testid="topic-type-badge"
      style={{
        fontSize: pxToRem(13),
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: 'var(--ion-color-medium)',
      }}
    >
      {selected.choiceLabel}
    </span>
  );
};

export default TopicTypeBadge;
